module.exports = __webpack_public_path__ + "static/media/InvoiceOpen.11c67f88.svg";